import { ApiType } from "@gymflow/common";
import { SessionPackSummaryDTO } from "@gymflow/types";
import { useQuery, UseQueryOptions } from "@tanstack/react-query";

import { sessionPackQueryKeys } from "./sessionPackQueryKeys";

export function useQueryCreditPackSummary(
  {
    api,
    opts,
    enabled,
  }: {
    api: ApiType;
    enabled?: boolean;
    opts?: Parameters<ApiType["creditPackApi"]["summary"]>[0];
  },
  queryOptions?: Omit<UseQueryOptions<SessionPackSummaryDTO>, "queryKey">,
) {
  return useQuery({
    queryKey: sessionPackQueryKeys.summary(opts),
    queryFn: async () => {
      return (await api.creditPackApi.summary(opts!)).data;
    },
    enabled: !!opts && enabled,
    ...queryOptions,
  });
}
